<template>
	<div>
		<!-- Header -->
		<div class="flex wrap xs-12 min-height mb2">
			<div class="flex xs-12 md-6 xs-left xs-middle">
				<h2 class="fs4 lh125 fw7 c1 mr4">{{ $t("offers") }}</h2>
			</div>
			<div class="flex xs-12 md-6 xs-left xs-bottom md-right md-middle">
				<j-button type="tertiary" @click="addOffer">
					<crm-icon name="add" color="c2" />{{ $t("add_offer") }}
				</j-button>
			</div>
		</div>

		<!-- Offers List -->
		<j-card
			class="flex xs-middle mb4 bg5 p4 cu2"
			v-for="(offer, i) in offers"
			:key="offer.id"
		>
			<!-- Data -->
			<div class="xs-10" @click="$emit('offer:click', offer.id)">
				<div class="fw7 c2 lh125">
					{{ offer.productName || "No product selected" }}
				</div>
				<div class="lh125">{{ offer.status || "---" }}</div>
				<div class="lh125">{{ offer.formattedPrice || "No premium" }}</div>
				<div class="lh125 c6">{{ offer.createdAt }}</div>
			</div>

			<div class="xs-2 flex xs-right">
				<!-- Actions -->
				<v-popover
					class="xs-5 flex xs-right"
					placement="bottom-end"
					popoverClass="xs-12 r2"
					popoverArrowClass="xs-0"
					popoverInnerClass="xs-12 r2 bg5 b1 bc7"
				>
					<j-button
						type="bordered"
						size="xsmall"
						:isLoading="isActionLoading === offer.id"
					>
						{{ $t("actions") }}
						<crm-icon name="down" color="c2" size="small" />
					</j-button>
					<template slot="popover">
						<div
							class="xs-12 p3 fw7 cError cu2"
							@click="removeOffer(offer.id)"
							v-close-popover
						>
							{{ $t("delete_offer") }}
						</div>
					</template>
				</v-popover>
			</div>
		</j-card>

		<!-- no offers -->
		<j-card v-if="!offers.length" class="mb4 bg5">
			<div class="xs-12 flex wrap xs-middle p4 c6">
				{{ $t("errors.no_offers") }}
			</div>
		</j-card>
	</div>
</template>

<script>
import JCard from "@/components/JCard"
import JButton from "@/components/JButton"
import CrmIcon from "@/components/CrmIcon"
import JTag from "@/components/JTag/"
import CoreModal from "@/modules/core/components/CoreModal"
import JBaseInputText from "@/components/JBaseInputText"
import dayjs from "dayjs"

import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default {
	components: { JCard, JButton, CrmIcon, JTag, CoreModal, JBaseInputText },

	data() {
		return {
			isActionLoading: false
		}
	},

	methods: {
		async addOffer() {
			const query = gql`
				mutation addOfferToProposal(
					$caseId: String!
					$proposalId: String!
					$input: addOfferInput!
				) {
					addOfferToProposal(
						caseId: $caseId
						proposalId: $proposalId
						input: $input
					) {
						status
						errors
					}
				}
			`
			const variables = {
				caseId: this.$store.state.caseManagement.caseId,
				proposalId: this.$store.state.caseManagement.proposalId,
				input: {
					productId: null
				}
			}

			const res = await api({ query, variables })

			if (res?.data?.addOfferToProposal?.status !== "success") {
				this.$store.dispatch("addMessage", {
					message: {
						type: "error",
						text:
							res?.errors ||
							res?.data?.addOfferToProposal?.errors ||
							res?.data?.addOfferToProposal?.errors_2.message ||
							"Oops ! An error occured."
					}
				})
			}

			this.fetchProposals()
		},

		async removeOffer(id) {
			const query = gql`
				mutation removeOfferFromProposal(
					$caseId: String!
					$proposalId: String!
					$offerId: String!
				) {
					removeOfferFromProposal(
						caseId: $caseId
						proposalId: $proposalId
						offerId: $offerId
					) {
						status
						errors
					}
				}
			`
			const variables = {
				caseId: this.$store.state.caseManagement.caseId,
				proposalId: this.$store.state.caseManagement.proposalId,
				offerId: id
			}

			const res = await api({ query, variables })

			if (res?.data?.removeOfferFromProposal?.status !== "success") {
				this.$store.dispatch("addMessage", {
					message: {
						type: "error",
						text:
							res?.errors ||
							res?.data?.removeOfferFromProposal?.errors ||
							res?.data?.removeOfferFromProposal?.errors_2.message ||
							"Oops ! An error occured."
					}
				})
			}

			this.fetchProposals()
		},

		fetchProposals() {
			this.$store.dispatch("caseManagement/fetchProposals", {
				caseId: this.$store.state.caseManagement.caseId
			})
		}
	},

	computed: {
		offers() {
			const dateFormat = this.$store.state.settings.dateFormat
			const proposal = this.$store.getters["caseManagement/proposal"]
			if (!proposal.basket) return []

			return proposal.basket.map(offer => ({
				id: offer.id,
				createdAt: offer.createdAt
					? dayjs(offer.createdAt).format(dateFormat)
					: "",
				status: offer.status,
				productName: offer?.product?.name || "",
				formattedPrice: offer?.premium?.formattedPrice || ""
			}))
		}
	}
}
</script>
